"use client";
import { jsx as i } from "react/jsx-runtime";
import l from "../../components/shape/Shape.js";
import { SHAPE_COLOR_MAPPING as n } from "../../constants/shapes.js";
const u = ({
  className: t,
  color: r = "light",
  shape: o,
  shapeTheme: e,
  priority: m
}) => o ? /* @__PURE__ */ i(l, { color: n[r], theme: e, priority: m, shape: o, className: t }) : null;
export {
  u as default
};
